function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), React.createElement("path", {
  fill: "#85D996",
  d: "M10 0C4.475 0 0 4.475 0 10v.037C.019 15.544 4.487 20 10 20c5.525 0 10-4.475 10-10S15.525 0 10 0zm0 1c3.944 0 7.3 2.544 8.513 6.075L10 10C7.8 8.469 5.381 6.444 3.381 6.444c-.731 0-1.375.244-1.894.631C2.7 3.544 6.056 1 10 1zM3.381 12.938h-.025v-.006c-1.706 0-2.275-1.356-2.35-2.594C1 10.225 1 10.112 1 10c.025-1.281.85-2.588 2.356-2.588 1.419 0 3.256 1.206 5.037 2.475.294.206.588.419.869.619-1.893 1.263-3.993 2.432-5.881 2.432z"
}), React.createElement("path", {
  fill: "#09825D",
  d: "M18.513 7.075a3.132 3.132 0 00-1.894-.631c-2 0-4.419 2.025-6.619 3.556 2.075 1.444 4.481 2.938 6.619 2.938.862 0 1.531-.194 2.044-.506C19.606 11.869 20 10.906 20 10c0-1.069-.55-2.231-1.487-2.925z"
})));